import { useNavigate, useLocation } from 'react-router-dom';
import { Trophy, CalendarDays, Globe, Medal, User } from 'lucide-react';

const tabs = [
  { path: '/dashboard', label: 'Home', icon: Trophy },
  { path: '/schedule', label: 'Events', icon: CalendarDays },
  { path: '/tours', label: 'Tours', icon: Globe },
  { path: '/rankings', label: 'Rank', icon: Medal },
  { path: '/profile', label: 'Profile', icon: User },
];

export const MobileNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Only show on main app pages (not landing, auth, or tournament detail)
  const showPaths = ['/dashboard', '/schedule', '/tours', '/rankings', '/profile', '/admin', '/personal-events'];
  const shouldShow = showPaths.some(p => location.pathname.startsWith(p));
  if (!shouldShow) return null;

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 z-50 sm:hidden bg-[#0A0A0A] border-t border-white/10 safe-area-bottom"
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around h-16 px-1">
        {tabs.map(({ path, label, icon: Icon }) => {
          // Highlight "Events" when on /schedule OR /personal-events (now a sub-tab)
          const isActive =
            location.pathname === path ||
            (path === '/schedule' && location.pathname.startsWith('/personal-events'));
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={`flex flex-col items-center justify-center gap-0.5 w-full h-full transition-colors ${
                isActive ? 'text-primary' : 'text-muted-foreground'
              }`}
              data-testid={`mobile-nav-${label.toLowerCase()}`}
            >
              <Icon className={`w-5 h-5 ${isActive ? 'text-primary' : ''}`} />
              <span className="text-[10px] font-medium">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
